import { Component } from '@angular/core';
import {
  CustomLayersConfigComponent
} from './custom-layers-config/custom-layers-config.component';
import { ActivatedRoute, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { MapThemeSettingsComponent } from './map-theme-settings/map-theme-settings.component';

export enum MapSettingsPage {
  MAP_THEMES = 'map-themes',
  CUSTOM_LAYERS = 'custom-layers',
}

@Component({
  selector: 'app-map-settings',
  imports: [
    CustomLayersConfigComponent,
    MapThemeSettingsComponent,
  ],
  templateUrl: './map-settings.component.html',
  styleUrl: './map-settings.component.scss',
})
export class MapSettingsComponent {

  editingSection = toSignal(
    this.activatedRoute.queryParamMap.pipe(
      map(params => {
        const editParam = params.get('edit');
        return editParam
          ? {
              editingPage: editParam as MapSettingsPage,
            }
          : null;
      })
    ),
    {
      initialValue: null,
    }
  );

  readonly MapSettingsPage = MapSettingsPage;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
  ) {}

  onEditClick(page: string, editing: boolean) {
    this.router.navigate([], {
      queryParams: {
        edit: editing ? page : undefined,
      },
    });
  }
}
